<h1 mat-dialog-title>Delete Dynamic Image Set</h1>
<mat-dialog-content>
  <div >Delete image set {{data.disId}}</div>
  <div  style="color:red;font-weight: bold">Warning: This cannot be undone</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button [mat-dialog-close]="true">Delete</button>
</mat-dialog-actions>
